<template>
  <div class="container">
    <div class="title">信用卡收款与转账费用对比</div>
    <div class="main">
      <div class="head">
        <div class="item">
          <span class="icon"></span>
          <span class="title1">空中云汇收单/入账/分发服务</span>
        </div>
        <div class="item">* 此过程中，万饰网不收取任何费用，所有费用均为空中云汇收取</div>
      </div>
      <div class="section">
        <div class="title1">1、线上信用卡收款</div>
        <div class="title2 mt-18" >a. 网关费+风控费</div>
        <table class="table">
          <thead>
              <tr>
                  <th>描述</th>
                  <th>要求</th>
                  <th>收费方式</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>网关费</td>
                  <td>2.35 HKD</td>
                  <td>每一笔收</td>
              </tr>
              <tr>
                  <td>防诈骗服务 + 3DS 费</td>
                  <td>0</td>
                  <td></td>
              </tr>
          </tbody>
        </table>
        <div class="title2 mt-28" >b. 每笔费用</div>
        <table class="table">
          <thead>
              <tr>
                  <th>费用</th>
                  <th>收单方式</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>4.3%</td>
                  <td>Visa/Mastercard/American <br> Express/JCB</td>
              </tr>
          </tbody>
        </table>
        <div class="title2 mt-28">c. 其它收单费用</div>
        <table class="table">
          <thead>
              <tr>
                  <th>费用描述</th>
                  <th>费用</th>
                  <th>收费方式</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>开户费</td>
                  <td>0.00 USD</td>
                  <td>一次性固定收费</td>
              </tr>
              <tr>
                  <td>月费</td>
                  <td>0.00 USD</td>
                  <td>每月固定收费</td>
              </tr>
              <tr>
                  <td>退款手续费</td>
                  <td>2.35 HKD</td>
                  <td>按笔收费（触发才需要）</td>
              </tr>
              <tr>
                  <td>拒付手续费</td>
                  <td>140 HKD</td>
                  <td>按笔收费（触发才需要）</td>
              </tr>
          </tbody>
        </table>
        <div class="title1 mt-38">2、TT线下转账：全球户所有收款账户<br>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;入账手续费 0.3%</div>
        <div class="title1 mt-38">3、分发</div>
        <table class="table">
          <thead>
              <tr>
                  <th>分发国家</th>
                  <th>收费方式</th>
              </tr>
          </thead>
          <tbody>
              <tr>
                  <td>结汇人民币到中国</td>
                  <td>0手续费</td>
              </tr>
              <tr>
                  <td>付款美金到中国</td>
                  <td>25 USD</td>
              </tr>
              <tr>
                  <td>付款到美国</td>
                  <td>3USD一笔（本地付款）15USD一笔（swift付款）</td>
              </tr>
              <tr>
                  <td>付款到香港</td>
                  <td>7USD一笔</td>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="img"></div>
    <div class="footer">Copyright©2022-2023粤ICP备17060038号-1</div>
  </div>
</template>
<script>
export default {
  name: 'BillingDetailAdvert',
  components: {},
  props: {},
  data() {
    return {
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created() { },
  mounted() { },
}
</script>
<style lang="less" scoped>
.container{
  width: 100%; 
  background: url('https://xhdata.wan4.com/advert-bg.png') 0 0/contain no-repeat,linear-gradient(180deg, #F4F4F4 0%, #FFF6F6 5.28%);
  .title{
    font-size: 46px;
    font-weight: 600;
    line-height: 54px;
    text-align: center;
    color: #3C589E;
    margin-top: 73px;
  }
  .title1{
    font-size: 32px;
    line-height: 44px;
    font-weight: bold;
    color: #333;
  }
  .title2{
    font-size: 26px;
    color: #333;
    height: 36px;
    line-height: 36px;
  }
  .mt-18{ margin-top: 18px; }
  .mt-28{ margin-top: 28px; }
  .mt-38{ margin-top: 38px; }

  .main{
    width: 702px;
    background: #fff;
    margin: 52px auto 0;
    border-radius: 8px;
    fill: #FFF;
    filter: drop-shadow(0px 2px 8px rgba(127, 5, 5, 0.15));
    .head{
      padding: 26px 24px;
      border-bottom: 2px solid #DCDCDC;
      .item .icon{
        width: 8px;
        height: 24px;
        background: #FF6634;
        display: inline-block;
        margin-right: 12px;
      }
      .item:nth-child(2){
        font-size: 22px;
        line-height: 30px;
        color: #FF7D00;
        margin-top: 8px;
      }
    }
    .section{
      padding: 24px;

    }
    .table{
      width: 100%;
      border-spacing: 0px;
      font-size: 24px;
      line-height: 34px;
      margin-top: 12px;
      tr{
        height: 66px;
      }
      th,td{
        padding: 18px 24px;
      }
      thead{
        color: #333;
        font-weight: 600;
        tr{
          background: #F5F6F7;
          text-align: left;
        }
      }
      tbody{
        color: #666;
        border-radius: 1px;
        tr{
          td{
            border-top: 1px solid #bbb;
            border-left: 1px solid #bbb;
          }
          td:last-of-type{
            border-right: 1px solid #bbb;
          }
        }
        tr:last-of-type{
          td{
            border-bottom: 1px solid #bbb;
          }
        }
      }
    }
  }
  .img{
    width: 100%;
    height: 68px;
    background: url("https://xhdata.wan4.com/advert-img1.png") no-repeat;
    background-size: contain;
    margin-top: 58px;
  }
  .footer{
    width: 100%;
    height: 100px;
    background: #131313;
    font-size: 24px;
    text-align: center;
    line-height: 100px;
    color: #999999;
  }
}
</style>